module.exports = __webpack_public_path__ + "static/img/icon_study_review.ec96ffd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_study_review.svg
// module id = RXj9
// module chunks = 10